import createReactComponent from '../createReactComponent';
export default createReactComponent('x-circle', 'XCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-6-3-6 6m0-6 6 6","key":"svg-0"}]]);